import { render, staticRenderFns } from "./MessageInputModal.vue?vue&type=template&id=ed3fdfc8&scoped=true&"
import script from "./MessageInputModal.vue?vue&type=script&lang=ts&"
export * from "./MessageInputModal.vue?vue&type=script&lang=ts&"
import style0 from "./MessageInputModal.vue?vue&type=style&index=0&id=ed3fdfc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed3fdfc8",
  null
  
)

export default component.exports